export const dossiersBasePath = 'dossiers';
export const dossiersCollectionBasePath = 'dossiers';
export const dossierValidationPath = ':idDossier/validation';
